import SplitType from 'split-type'
import { callAfterResize, disableWfScroll, mm, notHiddenAB, sel, selAll, stResizeObserver, vh } from './utils'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { lenis } from './lenis'

import 'vidstack/player/styles/default/theme.css'
import 'vidstack/player/styles/default/layouts/video.css'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'

// import { customPlayer } from './customPlayer'

export default function home2() {
  // mm.add('(min-width: 768px)', () => {
  gsap.registerPlugin(ScrollTrigger, SplitText)

  const navbarW$ = sel('.navbar-a')
  // const navbar$ = sel('#navbar' + notHiddenAB)
  const navbar$ = selAll('#navbar')
  const navbarHeight = navbar$[0].offsetHeight

  function navbarTheme(theme, el, transparent = false, offset = 0) {
    // if (scroll < 200) return
    let fg,
      bg,
      newFg,
      newBg = ''
    let bgInit,
      newBgInit = {}
    if (theme === 'light') {
      fg = 'white'
      bg = 'black'
      newFg = 'black'
      newBg = 'white'
    } else if (theme === 'dark') {
      fg = 'black'
      bg = 'white'
      newFg = 'white'
      newBg = 'black'
    }
    if (transparent) {
      bg = 'transparent'
      bgInit = { '--color--theme-init-bg': 'transparent' }
      newBgInit = { '--color--theme-init-bg': 'var(--color--theme-bg)' }
    }
    const navbarTl = gsap.fromTo(
      navbar$,
      { '--color--theme-fg': fg, '--color--theme-bg': bg, ...bgInit },
      { '--color--theme-fg': newFg, '--color--theme-bg': newBg, ...newBgInit, paused: true, immediateRender: false }
    )
    ScrollTrigger.create({
      trigger: el,
      start: 'top top+=' + navbarHeight,
      onEnter({ progress, direction, getVelocity }) {
        gsap.to(navbarTl, { duration: 0.5, progress: 1, ease: 'power1.out' })
      },
      onLeaveBack({ progress, direction, getVelocity }) {
        gsap.to(navbarTl, { duration: 0.5, progress: 0, ease: 'power1.out' })
      },
      // onToggle({ progress, direction, getVelocity }) {
      //   // only on entering the section (from top)
      //   if (progress > 0.2) return
      //
      //   // to reverse the easing
      //   gsap.to(navbarTl, { duration: 0.5, progress: direction === 1 ? 1 : 0, ease: 'power1.out' })
      // },
    })
  }
  // console.log(lenis.scroll, vh(100))
  //
  // if (lenis.scroll > vh(100)) {
  //   console.log('scroll')
  //
  //   gsap.set(navbar$, { '--color--theme-init-bg': '--color--theme-bg' })
  // }

  const hero2$ = sel('.hero2')
  const heroP$ = sel('.hero2__p')
  // const heroBtnW$ = sel('.hero2__btn-w .btn:not(.is--blur)' + notHiddenAB)
  const heroBtnW$ = selAll('.hero2__btn-w')
  const btnBlur$ = sel('.btn.is--blur')
  const heroBg = sel('.hero__bg-w')

  const alert$ = sel('.alert')
  if (alert$) {
    const alertHeight = alert$.offsetHeight
    // console.log(window.innerHeight, navbarHeight, alertHeight)
    // hero2$.style.height = window.innerHeight - navbarHeight - alertHeight + 'px'
    //
    gsap.set(hero2$, { height: window.innerHeight - navbarHeight - alertHeight + 'px', marginTop: -navbarHeight - alertHeight + 'px' })
  }

  const heroHsT = new SplitType('.hero2__h', { types: 'words, chars' })

  gsap
    .timeline()
    .from(heroBg, { scale: 1.1, ease: 'power1.out', duration: 3 })
    .from(
      heroHsT.chars,
      {
        opacity: 0,
        filter: 'blur(50px)',
        stagger: {
          amount: 0.5,
          // from: 'end',
        },
        duration: 0.5,
        ease: 'none',
        // ease: 'power1.out',
      },
      0.5
    )
    .from(heroP$, { opacity: 0, ease: 'power1.out', duration: 1 }, '>-0.5')
    .from(heroBtnW$, { autoAlpha: 0, ease: 'power1.out', duration: 1 }, '>-0.5')
    .fromTo(btnBlur$, { backdropFilter: 'blur(0px)', autoAlpha: 0 }, { autoAlpha: 1, backdropFilter: 'blur(10px)', duration: 1 }, '<+0.1')
    .from(alert$, { autoAlpha: 0, duration: 1 }, 1)
    .from(navbar$, { autoAlpha: 0, opacity: 1, duration: 1 }, 1.3)
  // .from(navbar$, { autoAlpha: 0, ease: 'power1.out', duration: 1 }, '>-0.75')

  const quoteSec$ = sel('.quote-sec')
  // const quotePsT = new SplitType('.quote__p', { types: 'words' })
  // navbarTheme('light', quoteSec$, true)

  ScrollTrigger.create({
    trigger: quoteSec$,
    start: 'top bottom=+1',
    end: 'top top',
    scrub: true,
    pin: hero2$,
    pinSpacing: false,
  })

  // gsap.set(quotePsT.words, { color: '#ddd' })
  // gsap.to(quotePsT.words, {
  //   color: 'black',
  //   stagger: 0.1,
  //   // scrollTrigger: {
  //   //   trigger: quoteSec$,
  //   //   // start: 'top center',
  //   //   // end: 'bottom 75%',
  //   //   start: 'top top',
  //   //   end: 'bottom top',
  //   //   pin: true,
  //   //   scrub: true,
  //   // },
  //   scrollTrigger: {
  //     trigger: quoteSec$,
  //     start: 'top 50%',
  //     end: 'bottom 70%',
  //     scrub: true,
  //   },
  // })

  function servicesSec() {
    const serviceSec$ = sel('.home-service-sec')
    if (!serviceSec$) return
    const serviceLo$ = sel('.home-service-lo')
    const serviceH$ = sel('.home-service__title')
    const serviceItem$a = selAll('.home-service__item')
    const serviceCta$ = sel('.home-service__cta')
    const serviceCtaH$ = sel('.home-service__cta h2')
    const serviceCtaP$ = sel('.home-service__cta__p')
    const serviceCtaBtn$ = sel('.home-service__cta__btn-w')
    // navbarTheme('dark', serviceSec$)

    gsap.set(serviceLo$, { y: '-100vh' })
    ScrollTrigger.create({
      trigger: serviceSec$,
      start: 'top bottom',
      // end: 'top top',
      // end: 'top+=' + vh(50) + ' top',
      end: '+=' + vh(100),
      scrub: true,
      pin: serviceLo$,
      pinSpacing: false,
      // animation: gsap.from(serviceLo$, { opacity: 0, ease: 'none' }),
    })
    ScrollTrigger.create({
      trigger: serviceSec$,
      start: 'top center',
      end: 'top+=' + vh(20) + ' top',
      scrub: true,
      animation: gsap.from([serviceH$, ...serviceItem$a], { opacity: 0, y: 20, ease: 'power1.out', stagger: 0.3 }),
    })

    // ScrollTrigger.create({
    //   trigger: serviceCta$,
    //   start: 'top 50%',
    //   end: 'top top',
    //   scrub: true,
    //   animation: gsap.from([serviceCtaH$, serviceCtaP$, serviceCtaBtn$], { opacity: 0, y: 40, ease: 'none', stagger: 0.3 }),
    // })
  }
  servicesSec()

  // const testSec$ = sel('.test-sec')
  // const testLo$ = sel('.test__lo')
  // const testItem$a = selAll('.test__item')
  // let testItemRight$a = []
  // const testLoOffset = testLo$.offsetLeft
  // testItem$a.forEach((el, i) => {
  //   const elOffset = el.offsetLeft
  //   console.log(testLoOffset - elOffset)
  //
  //   if (testLoOffset - elOffset < 0) {
  //     testItemRight$a.push(el)
  //   }
  // })
  // gsap.set(testItemRight$a, { y: -100 })
  //
  //
  // ScrollTrigger.create({
  //   trigger: testSec$,
  //   start: 'top bottom',
  //   endTrigger: testLo$,
  //   end: 'bottom top',
  //   scrub: true,
  //   animation: gsap.to(testItemRight$a, { y: -400, ease: 'power1.in' }),
  // })

  // const testQuoteW$ = sel('.test__quote-w')
  // const testQuote$ = sel('.test__quote')
  // gsap.set(testQuote$, { y: '-60vh', opacity: 0 })
  // ScrollTrigger.create({
  //   trigger: testLo$,
  //   start: 'bottom 60%',
  //   endTrigger: testQuoteW$,
  //   end: 'bottom bottom',
  //   pin: testQuote$,
  //   pinSpacing: false,
  //   scrub: true,
  //   animation: gsap.to(testQuote$, { opacity: 1, ease: 'none' }),
  // })

  const footer$ = sel('.footer2')
  const footerCtaW$ = sel('.footer2__cta__info-w')
  const footerCta$ = sel('.footer2__cta__info')
  const footerBg$ = sel('.footer2__cta__bg')
  // navbarTheme('dark', footer$)

  /*
  gsap.set(footerCta$, { y: '-100vh' })
  ScrollTrigger.create({
    trigger: footerCtaW$,
    start: 'top bottom',
    end: 'top top',
    pin: footerCta$,
    pinSpacing: false,
    scrub: true,
    // animation: gsap.to(footerCta$, { y: 0, ease: 'none' }),
  })

  gsap.set(footerBg$, { y: -vh(80) })
  ScrollTrigger.create({
    trigger: footer$,
    start: 'top bottom',
    end: 'bottom bottom',
    scrub: 0,
    animation: gsap.to(footerBg$, { y: vh(30), ease: 'none' }),
  })
    */
  //
  //

  // Peter video on Social LP
  async function videoModal() {
    const videoBtn$ = sel('#peterVideoBtn')
    if (!videoBtn$) return

    const sec$ = sel('.peter-quote-sec')
    const close$ = sec$.querySelector('.mod__x-w')
    const modW$ = sec$.querySelector('.mod-w')
    const mod$ = sec$.querySelector('.mod')
    const bg$ = sec$.querySelector('.mod-bg')
    modW$.classList.add('display-hide')

    const _player = sec$.querySelector('.custom_player')
    const player = await VidstackPlayer.create({
      target: _player,
      // src: 'youtube/4UgnVc7kRxE',
      // src: 'vimeo/1061484821',
      poster: 'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/67ec2aaf454cc0ab8e781425_hero_q85.webp',
      crossOrigin: true,
      playsInline: true,
      viewType: 'video',
      load: 'idle',
      layout: new VidstackPlayerLayout(),
    })

    const tl = gsap
      .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
      .to(
        {},
        {
          onStart: () => {
            modW$.classList.remove('display-hide')
          },
          onReverseComplete: () => {
            modW$.classList.add('display-hide')
          },
          duration: 0.1,
        }
      )
      .to(modW$, { opacity: 1 })
      .from(mod$, { y: 50 }, 0)

    const closeModal = (e) => {
      e?.stopImmediatePropagation()
      tl.reverse()
      player.pause()
    }

    videoBtn$.onclick = (e) => {
      // console.log('pl', player.state.canPlay)
      tl.play()

      if (player.state.canPlay) {
        player.play()
      } else {
        player.addEventListener(
          'can-play',
          (event) => {
            // console.log('canplay')
            player.play()
          },
          { once: true }
        )
      }
    }
    ;[close$, bg$].forEach((el) => {
      el.onclick = closeModal
    })

    player.addEventListener('ended', (event) => {
      closeModal()
    })

    callAfterResize(() => closeModal())
  }
  videoModal()
  // console.log('videoModal')

  stResizeObserver()
  // })
}
